import React from 'react';

import cx from 'classnames';
import { createPortal } from 'react-dom';

import Minimize from 'components/shared/Icon/icons/Minimize';
import Loader from 'components/shared/Loader';
import Tooltip, { TooltipText } from 'components/shared/Tooltip';
import Text from 'components/shared/Typography/Text';

import Preview from '../Preview/Landing';
import { useBuilderPagePreview } from './functions';
import s from './index.module.css';

function BuilderPagePreview({ pagePreviewId }) {
  const { visible, page, isLoading, wrapperRef, height, toggleWindow } = useBuilderPagePreview({ pagePreviewId });

  const inner = (
    <div className={cx(s.wrapper, !visible && s.autoHeight)} ref={wrapperRef}>
      <div className={s.header}>
        <Text accent isStrong className={s.headerText}>
          VIEWING UPDATED VERSION
        </Text>
        <div className={s.minimize} onClick={toggleWindow} data-tip data-for="minimize">
          <Minimize />
          <Tooltip id="minimize">
            <TooltipText>{visible ? 'Minimize' : 'Maximize'} window</TooltipText>
          </Tooltip>
        </div>
      </div>
      <div className={cx(s.content, !visible && s.contentHidden)} style={{ '--modalHeight': height - 37 + 'px' }}>
        {(isLoading || !page) && <Loader isFillBlock />}
        {!isLoading && page && (
          <Preview page={page} containerClassName={s.previewVars} landingData={page.landing?.pages?.[0]} isPreview />
        )}
      </div>
    </div>
  );
  return createPortal(inner, document.body);
}

export default BuilderPagePreview;
